var _defs, _rect, _rect2, _g, _text, _text2, _text3, _text4, _text5, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpanOfControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 630",
    width: 1200,
    height: 630,
    role: "img",
    "aria-label": "Span of control: one leader coordinating a wide team through the BossDrop AI coordination layer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#171523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: 0.5,
    cy: 0.42,
    r: 0.65
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7a4e6",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7a4e6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b7a4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f6cf6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("style", null, "\n      .h  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 800; fill: #f4f0fc; }\n      .s  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 600; fill: #b8b2cc; }\n      .eyebrow { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #cfc3ee; letter-spacing: 4px; }\n      .lab { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #121020; }\n      .node { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #e2d9f5; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#glow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2a2547",
    strokeWidth: 1,
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90 H1200 M0 180 H1200 M0 270 H1200 M0 360 H1200 M0 450 H1200 M0 540 H1200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0 V630 M300 0 V630 M450 0 V630 M600 0 V630 M750 0 V630 M900 0 V630 M1050 0 V630"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 120,
    className: "eyebrow",
    fontSize: 20
  }, "SPAN OF CONTROL")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 188,
    className: "h",
    fontSize: 62
  }, "One leader.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 256,
    className: "h",
    fontSize: 62
  }, "The whole team.")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 304,
    className: "s",
    fontSize: 24
  }, "Coordination is now software.")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 588,
    className: "s",
    fontSize: 20,
    opacity: 0.8
  }, "BOSSDROP.AI")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 430,
    r: 46,
    fill: "url(#gold)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 415,
    r: 15,
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 452 a24 20 0 0 1 48 0 z",
    fill: "#121020"
  }), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 510,
    textAnchor: "middle",
    className: "node",
    fontSize: 20
  }, "Leader"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#ai)",
    strokeWidth: 3,
    opacity: 0.9,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296 430 C 360 430, 380 315, 470 315"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 286,
    width: 250,
    height: 58,
    rx: 29,
    fill: "url(#ai)",
    filter: "url(#soft)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 286,
    width: 250,
    height: 58,
    rx: 29,
    fill: "url(#ai)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 322,
    textAnchor: "middle",
    className: "lab",
    fontSize: 21
  }, "BossDrop AI layer"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#ai)",
    strokeWidth: 2.5,
    opacity: 0.75,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720 315 C 820 315, 860 150, 980 150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 315 C 830 315, 880 220, 1000 220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 315 C 840 315, 900 290, 1020 290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 315 C 840 315, 900 340, 1020 360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 315 C 830 315, 880 410, 1000 430"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 315 C 820 315, 860 480, 980 500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 315 C 800 315, 840 100, 900 100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 315 C 800 340, 830 520, 900 540"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#1d1a2e",
    stroke: "#665a9c",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 100,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 150,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 220,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 290,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 360,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 430,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 500,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 540,
    r: 22
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#cfc3ee"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 94,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 144,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 214,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 284,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 354,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 424,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 494,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 534,
    r: 6
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#cfc3ee",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884 116 a16 12 0 0 1 32 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964 166 a16 12 0 0 1 32 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984 236 a16 12 0 0 1 32 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004 306 a16 12 0 0 1 32 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004 376 a16 12 0 0 1 32 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984 446 a16 12 0 0 1 32 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964 516 a16 12 0 0 1 32 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884 556 a16 12 0 0 1 32 0 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanOfControl);
export default __webpack_public_path__ + "static/media/span-of-control.719a69eb8b10480c3915ed7994066ca3.svg";
export { ForwardRef as ReactComponent };